// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseLoader_container_3SpJH","bobber":"BaseLoader_bobber_dbtPi","loading":"BaseLoader_loading_xROr8"};